import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import CustomToast from "src/components/CustomToast/CustomToast";
import cmsClient from "src/services/cmsClient";

const editQuickLink = async (payload: Partial<IQuickLink>) => {
	const response = await cmsClient.put<IQuickLink>(
		`/homepage/admin/quicklink/${payload.id}/`,
		payload
	);

	return response.data;
};

const useEditQuickLink = () => {
	const queryClient = useQueryClient();

	const onSuccess = () => {
		toast.success(
			<CustomToast type="Success" message="Quick link updated successfully" />,
			{ hideProgressBar: true }
		);

		queryClient.invalidateQueries(["quick-links"]);
	};

	const onError = () => {
		toast.error(
			<CustomToast type="Error" message="Something went wrong, try again" />,
			{ hideProgressBar: true }
		);
	};

	const mutation = useMutation(editQuickLink, {
		onError,
		onSuccess
	});

	return mutation;
};

export default useEditQuickLink;
